// libraries.
import { useSelector } from 'react-redux';
import { skipToken } from '@reduxjs/toolkit/query';
import { useDebounce } from '@uidotdev/usehooks';

// domains.
import { getCountry } from '@domains/user/store/slices/user-slice/user-slice';
import {
  getOrchestratorNid,
  getSelectedAlias,
} from '../store/slices/domainOrchestratorPricingCommittee.slice';
import { useGetCurrentOrchestratorQuery } from '../store/services/getOrchestratorPricingCommittee';

interface UseCurrentOrchestratorOptions {
  debounceMs?: number;
}

export const useCurrentOrchestrator = ({
  debounceMs = 1500,
}: UseCurrentOrchestratorOptions = {}) => {
  const country = useSelector(getCountry);
  const nid = useSelector(getOrchestratorNid);
  const workflowAlias = useSelector(getSelectedAlias);

  const debouncedNid = useDebounce(nid, debounceMs);

  const shouldSkip = !country || !debouncedNid;
  const queryArg = shouldSkip
    ? skipToken
    : { country, nid: debouncedNid, workflow_alias: workflowAlias };

  const currentOrchestrator = useGetCurrentOrchestratorQuery(queryArg);

  return { currentOrchestrator, debouncedNid, rawNid: nid };
};
